import * as yup from 'yup'

export const schema = yup
  .object({
    collection: yup.object({ value: yup.string(), label: yup.string() }).required('Required'),
  })
  .required()
